import { render, staticRenderFns } from "./information.vue?vue&type=template&id=4b428eb6&scoped=true"
import script from "./information.vue?vue&type=script&lang=js"
export * from "./information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b428eb6",
  null
  
)

export default component.exports